<template>
  <div>
    <Layout ref="layoutRef" :selectedOption="3" />
    <h4>Clasificación de Elementos</h4>
    <hr />

    <DataTable
      :data="claselems"
      :columns="[
        { label: 'Nombre',       field: 'nombre' },
        { label: 'Tipo Elemento', field: 'tipoElemNombre' },
      ]"
      idField="idClasElem"
      mensajeVacio="No hay registros de clasificación de elementos."
      :mostrarBotonNuevo="esAdmin"
      :mostrarEditar="esAdmin"
      :mostrarVer="esAdmin"
      :mostrarEliminar="esAdmin"
      @refresh="getDataPaginaTodos"
      @create="abrirModalCrear"
      @edit="row => abrirModalEditar(row.idClasElem)"
      @view="row => abrirEditar(row.idClasElem)"
      @delete="row => deleteClasElem(row.idClasElem)"
    />

    <!-- ── Modal ──────────────────────────────────────────────────── -->
    <div
      class="modal fade"
      id="ventanaModal"
      tabindex="-1"
      aria-hidden="true"
      v-if="modalWindow"
    >
      <div class="modal-dialog modal-lg">
        <div class="modal-content">
          <div class="modal-header bg-primary">
            <h5 class="modal-title text-white">{{ titulo }}</h5>
            <button
              type="button"
              class="btn-close btn-close-white"
              data-bs-dismiss="modal"
              aria-label="Close"
            ></button>
          </div>
          <div class="modal-body">
            <!-- ID solo en edición -->
            <div class="mb-3" v-if="btnEditar">
              <div class="row">
                <div class="col-2"><label class="form-label fw-bold">ID</label></div>
                <div class="col-10">
                  <input type="text" class="form-control" v-model="datoClasElem.idClasElem" disabled />
                </div>
              </div>
            </div>
            <!-- Tipo Elemento -->
            <div class="mb-3">
              <div class="row">
                <div class="col-2"><label class="form-label fw-bold">Tipo Elem</label></div>
                <div class="col-10">
                  <select class="form-select" v-model="datoClasElem.idTipoElem">
                    <option disabled value="">Seleccione...</option>
                    <option
                      v-for="tipoElem in tipoElems"
                      :value="tipoElem.idTipoElem"
                      :key="tipoElem.idTipoElem"
                    >
                      {{ tipoElem.nombre }}
                    </option>
                  </select>
                </div>
              </div>
            </div>
            <!-- Nombre -->
            <div class="mb-3">
              <div class="row">
                <div class="col-2"><label class="form-label fw-bold">Nombre</label></div>
                <div class="col-10">
                  <textarea
                    class="form-control"
                    v-model="datoClasElem.nombre"
                    style="text-transform:uppercase"
                    rows="3"
                  ></textarea>
                </div>
              </div>
            </div>
          </div>
          <div class="modal-footer">
            <button
              type="button"
              class="btn btn-primary"
              @click.prevent="guardarClasElem"
              v-if="btnCrear"
            >
              <span class="material-icons me-1" style="font-size:18px;vertical-align:middle">save</span>
              Guardar
            </button>
            <button
              type="button"
              class="btn btn-warning"
              @click.prevent="actualizarClasElem"
              v-if=" btnEditar && esAdmin "
            >
              <span class="material-icons me-1" style="font-size:18px;vertical-align:middle">update</span>
              Actualizar
            </button>
            <button type="button" class="btn btn-secondary" data-bs-dismiss="modal">
              Cerrar
            </button>
          </div>
        </div>
      </div>
    </div>

    <Footer />
  </div>
</template>

<script>
import Layout          from "@/components/Layout.vue";
import Footer          from "@/components/Footer.vue";
import DataTable       from "@/components/DataTable.vue";
import api             from "@/services/api";
import { validarForm } from "@/modules/validacionesForms.js";
import Swal            from "sweetalert2";
import * as $          from "jquery";
window["$"]      = $;
window["jQuery"] = $;

export default {
  components: { Layout, Footer, DataTable },
  data() {
    return {
      claselems:    [],
      datoClasElem: {},
      titulo:       "",
      btnCrear:     false,
      btnEditar:    false,
      modalWindow:  true,
      tipoElems:    [],
    };
  },
  computed: {
    esAdmin() {
      const idPerfil = Number(window.sessionStorage.getItem("idPerfil"));
      return idPerfil === 1;
    }
  },
  mounted() {
    this.getDataPaginaTodos();
    this.$refs.layoutRef.toggleProcesos();
    this.$refs.layoutRef.toggleReportes();
    this.$refs.layoutRef.toggleParametros();
    this.$refs.layoutRef.toggleAyuda();
    this.fetchTipoElems();
  },
  methods: {
    getDataPaginaTodos() {
      api.get("/vwclaselems")
        .then(r => { this.claselems = Array.isArray(r.data) ? r.data : []; })
        .catch(e => console.error("Error al cargar claselems:", e));
    },
    async fetchTipoElems() {
      try {
        const r    = await api.get("/vwtipoelems");
        this.tipoElems = r.data;
      } catch (e) {
        console.error("Error fetching tipoElems:", e.response?.data || e.message);
      }
    },
    validarForm() {
      return validarForm(this.datoClasElem, ["idTipoElem", "nombre"], ["idTipoElem", "nombre"]);
    },
    async guardarClasElem() {
      if (this.validarForm() !== 1) return;
      try {
        await api.post("/claselems", this.datoClasElem);
        $("#ventanaModal").modal("hide");
        Swal.fire({ icon: "success", title: "¡Correcto!", text: "Registro creado exitosamente." });
        this.getDataPaginaTodos();
      } catch {
        Swal.fire({ icon: "error", title: "Error", text: "Inténtelo de nuevo." });
      }
    },
    async actualizarClasElem() {
      if (this.validarForm() !== 1) return;
      try {
        await api.post("/claselems", this.datoClasElem);
        $("#ventanaModal").modal("hide");
        Swal.fire({ icon: "success", title: "¡Correcto!", text: "Registro actualizado exitosamente." });
        this.getDataPaginaTodos();
      } catch (error) {
        Swal.fire({ icon: "error", title: "Error", text: "Inténtelo de nuevo." });
        const arr = Object.values(error.response?.data?.errors || {});
        arr.forEach(e => Swal.fire(String(e)));
      }
    },
    async deleteClasElem(idClasElem) {
      const confirm = await Swal.fire({
        title: "¿Eliminar registro?",
        text: "Esta acción no se puede deshacer.",
        icon: "warning",
        showCancelButton: true,
        confirmButtonText: "Sí, eliminar",
        cancelButtonText: "Cancelar",
      });
      if (!confirm.isConfirmed) return;
      try {
        await api.delete("/claselems/" + idClasElem);
        this.getDataPaginaTodos();
      } catch {
        Swal.fire({ icon: "error", title: "Error", text: "No se pudo eliminar." });
      }
    },
    abrirModalCrear() {
      this.modalWindow  = true;
      this.datoClasElem = {};
      this.titulo       = "Crear Clasificación de Elementos";
      this.btnCrear     = true;
      this.btnEditar    = false;
      this.$nextTick(() => $("#ventanaModal").modal("show"));
    },
    async abrirModalEditar(idClasElem) {
      this.modalWindow = true;
      this.titulo      = "Editar Clasificación de Elementos";
      this.btnCrear    = false;
      this.btnEditar   = true;
      try {
        const resp        = await api.get("/vwclaselems/" + idClasElem);
        this.datoClasElem = resp.data;
      } catch (e) {
        console.error("Error al cargar claselem:", e);
        return;
      }
      $("#ventanaModal").modal("show");
    },
    abrirEditar(idClasElem) {
      if (idClasElem != null) this.$router.push("/claselem_elemento/" + idClasElem);
    },
  },
};
</script>